import { Box, Typography, useTheme } from "@mui/material";

import { capitalizeFirstLetter } from "~/lib/helpers";
import { TempZone, tempZoneIconMap } from "~/lib/tempZone";

type Props = {
  tempZone: TempZone;
};

export function TemperatureZoneRibbon({ tempZone }: Props) {
  const { palette } = useTheme();
  const Icon = tempZoneIconMap[tempZone];
  const bgColor = palette[tempZone].main;

  return (
    <Box
      aria-label={`${tempZone} temperature zone`}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-end",
        bgcolor: bgColor,
        pb: 1.5,
        gap: 1,
        width: 48
      }}
    >
      <Typography
        variant="body1"
        sx={{
          writingMode: "vertical-rl",
          transform: "rotate(180deg)",
          fontWeight: 400,
          fontSize: "1.4rem",
          letterSpacing: "0.05em",
          color: palette.text.primary
        }}
      >
        {capitalizeFirstLetter(tempZone)}
      </Typography>
      <Icon
        width={32}
        height={32}
        style={
          tempZone === "chilled"
            ? { transform: "rotate(-90deg)", transformOrigin: "center" }
            : undefined
        }
      />
    </Box>
  );
}
